import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

export const StaticOptionField = ({
  label,
  field,
  control,
  options,
  disabled,
}) => {
  return (
    <Controller
      label={label}
      name={field}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          disablePortal
          size="small"
          disabled={disabled}
          options={options}
          noOptionsText="Nada encontrado"
          value={value}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(_event, newValue) => {
            onChange(newValue);
          }}
          renderInput={params => <TextField {...params} label={label} />}
        />
      )}
    />
  );
};
